import { CUSTOMER_APIS } from "@/api_framework/api_config";
import { ICustomerCreationRequestBody, ICustomerCreationResponse } from "@/api_framework/api_modals/Users";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { RESET_CUSTOMER_PROFILE } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import axios, { AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
// returns new created userId
export const useCustomerCreationAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const [newUserId, setNewUserId] = useState<string | null>("");
  const { sendCurl } = useCurlLogger();
  const toggleLoading = (toggleState: boolean) => {
    dispatch(
      setLoading({
        key: "isCustomerCreationInProgress",
        status: toggleState,
      }),
    );
  };

  const execute = useCallback(async (formData: ICustomerCreationRequestBody): Promise<string | null> => {
    toggleLoading(true);
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key) as string;
      const requestHeaders = new Headers();
      requestHeaders.append("Authorization", `${accessToken}`);
      const response: string = await axios
        .post(CUSTOMER_APIS?.CREATE_CUSTOMER?.baseURL ?? "", formData, {
          headers: { Authorization: requestHeaders.get("Authorization") },
        })
        .then((res: AxiosResponse<ICustomerCreationResponse>) => {
          toggleLoading(false);

          if (res.data.status === true) {
            toast.success(`${formData.name} customer created successfully.`);
            setNewUserId(res.data.data.user_id);
            /* Reset customer profile when a new user is created. */
            dispatch(RESET_CUSTOMER_PROFILE());
            return res.data.data.user_id;
          } else {
            return null;
          }
        })
        .catch((e: any) => {
          captureError(e);
          sendCurl(e.config["curlCommand"]);
          toggleLoading(false);
          // Treat it like AxiosError

          return null;
        });
      return response;
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      return null;
    }
    return null;
  }, []);
  return { newUserId, execute };
};
